import { render, staticRenderFns } from "./attributes.vue?vue&type=template&id=784b2a4c&scoped=true"
import script from "./attributes.vue?vue&type=script&lang=js"
export * from "./attributes.vue?vue&type=script&lang=js"
import style0 from "./attributes.vue?vue&type=style&index=0&id=784b2a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784b2a4c",
  null
  
)

export default component.exports